import { render, staticRenderFns } from "./YwInfo.vue?vue&type=template&id=64d63572&scoped=true&"
import script from "./YwInfo.vue?vue&type=script&lang=js&"
export * from "./YwInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d63572",
  null
  
)

export default component.exports